import React from "react";
import { useAnalyticTrackedActionDispatch, type Action } from "~/analytics/Analytics";
export function useTrackedGitConnectionEvent() {
    const trackAction = useAnalyticTrackedActionDispatch();
    return React.useCallback((name: string, action: Action, callback: () => Promise<void>) => trackAction(name, {
        action: action,
        resource: "GitHub Connection",
    }, callback), [trackAction]);
}
